import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "flex flex-col h-screen mt-4",
  style: {"width":"70vw","font-family":"sans-serif","padding":"40px","text-align":"justify"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"font-size":"28px","margin-bottom":"15px"} }, "Gestione Cookie"),
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_4 = {
  key: 0,
  style: {"font-size":"24px","margin-bottom":"15px"}
}
const _hoisted_5 = {
  key: 1,
  style: {"font-size":"24px","margin-bottom":"15px"}
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<ul style=\"list-style-type:disc;\"><li><strong>consent</strong> - Consente al sistema di memorizzare le informazioni temporali di accettazione. </li><li><strong>XSRF-TOKEN</strong> - Il sistema genera automaticamente un &quot;token&quot; CSRF per ogni sessione utente attiva gestita dall&#39;applicazione. Questo token viene utilizzato per verificare che l&#39;utente autenticato sia quello che sta effettivamente effettuando le richieste all&#39;applicazione. </li><li><strong>laravel_session</strong> - Le sessioni forniscono un modo per archiviare le informazioni sull&#39;utente attraverso le richieste. </li><li><strong>Local Storage e Session Storage</strong> - Questi strumenti vengono utilizzati per memorizzare dati specifici della vostra sessione di navigazione o della vostra interazione con il nostro sito. I dati in session storage vengono rimossi alla chiusura del browser, mentre quelli nel local storage scadono dopo 120 minuti. </li><li><strong>Google analytics cookies</strong> - Google Analytics e&#39; uno strumento semplice e di facile utilizzo che aiuta i proprietari di siti web a misurare il modo in cui gli utenti interagiscono con i contenuti del sito web. </li></ul><p><br></p>", 2)
const _hoisted_8 = {
  key: 2,
  style: {"text-align":"center"}
}
const _hoisted_9 = {
  key: 3,
  style: {"text-align":"center"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", { class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" }, "Consenti l'utilizzo dei cookie.", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "flex flex-col h-screen mt-4",
  style: {"width":"70vw","font-family":"sans-serif","padding":"40px","text-align":"justify"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { style: {"font-size":"26px","margin-bottom":"10px"} }, "Cookie Policy"),
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_14 = { class: "container" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_16 = { style: {"margin-top":"20px","margin-bottom":"15px"} }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<h1><strong>Cookie</strong></h1><p> Questo sito fa uso di cookie, file di testo che vengono registrati sul terminale dell&#39;utente oppure che consentono l&#39; accesso ad informazioni sul terminale dell&#39;utente. I cookie permettono di conservare informazioni sulle preferenze dei visitatori, sono utilizzati al fine di verificare il corretto funzionamento del sito e di migliorarne le funzionalita&#39; personalizzando il contenuto delle pagine in base al tipo del browser utilizzato, oppure per semplificarne la navigazione automatizzando le procedure (es. Login, lingua sito), ed infine per l&#39;analisi dell&#39;uso del sito da parte dei visitatori. </p><p> Il presente sito fa uso di <strong>cookie analitici </strong> non obbligatori e di <strong>cookie tecnici</strong>, utilizzati al solo fine di effettuare la trasmissione di una comunicazione elettronica, per garantire la corretta visualizzazione del sito e la navigazione all&#39; interno di esso. Inoltre, consentono di distinguere tra i vari utenti collegati al fine di fornire un servizio richiesto all&#39;utente giusto (Login), e per motivi di sicurezza del sito. Alcuni di questi cookie sono eliminati alla chiusura del browser (cookie di sessione), altri hanno una durata maggiore (come ad esempio il cookie necessario per memorizzare il consenso dell&#39;utente in relazione all&#39;uso dei cookie, che dura 1 anno). Per questi cookie non occorre consenso; </p><p> - <strong> cookie di analisi </strong> , utilizzati direttamente dal gestore del sito per raccogliere informazioni, in forma aggregata, sul numero degli utenti e su come questi visitano il sito stesso. Sono assimilati ai cookie tecnici se il servizio e&#39; anonimizzato. </p><p> - <strong> cookie di profilazione e marketing, </strong> utilizzati esclusivamente da terze parti diverse dal titolare del presente sito per raccogliere informazioni sul comportamento deli utenti durante la navigazione, e sugli interessi e abitudini di consumo, anche al fine di fornire pubblicita&#39; personalizzata. </p><p> Cliccando <strong> &quot;Accetta Tutti&quot; sul banner </strong> presente al primo accesso al sito oppure <strong> navigando il sito, </strong> il visitatore acconsente espressamente all&#39;uso dei cookie e delle tecnologie similari, e in particolare alla registrazione di tali cookie sul suo terminale per le finalita&#39; sopra indicate, oppure all&#39;accesso tramite i cookie ad informazioni sul suo terminale. </p>", 6)
const _hoisted_23 = [
  _hoisted_17
]
const _hoisted_24 = { style: {"margin-top":"20px","margin-bottom":"15px"} }
const _hoisted_25 = /*#__PURE__*/_createStaticVNode("<h1><strong> Disabilitazione cookie </strong></h1><p> L&#39;utente puo&#39; rifiutare l&#39;utilizzo dei cookie e, in qualsiasi momento, puo&#39; revocare un consenso gia&#39; fornito. Poiche&#39; i cookie sono collegati al browser utilizzato, <strong> POSSONO ESSERE DISABILITATI DIRETTAMENTE DAL BROWSER, </strong> cosi rifiutando/revocando il consenso all&#39;uso dei cookie, oppure accedendo all&#39;apposita schermata posta in alto. </p><p><br> Le istruzioni per la disabilitazione dei cookies si trovano alle seguenti pagine web: </p><div><a title=\"Attivare e disattivare i cookie\" href=\"https://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie\" target=\"_blank\" rel=\"noopener noreferrer\">Mozilla Firefox</a> - <a title=\"Come bloccare, abilitare o consentire i cookie\" href=\"https://support.microsoft.com/it-it/help/17442/windows-internet-explorer-delete-manage-cookies\" target=\"_blank\" rel=\"noopener noreferrer\">Microsoft Internet Explorer</a> - <a title=\"Come bloccare, abilitare o consentire i cookie\" href=\"https://support.microsoft.com/it-it/help/17442/windows-internet-explorer-delete-manage-cookies\" target=\"_blank\" rel=\"noopener noreferrer\">Microsoft Internet Explorer</a> - <a title=\"Eliminare i cookie\" href=\"https://support.microsoft.com/it-it/help/4027947/windows-delete-cookies\" target=\"_blank\" rel=\"noopener\">Microsoft Edge</a> - <a title=\"Cancellazione, attivazione e gestione dei cookie in Chrome\" href=\"https://support.google.com/chrome/answer/95647?hl=it\" target=\"_blank\" rel=\"noopener noreferrer\">Google Chrome</a> - <a title=\"Cookie\" href=\"http://help.opera.com/Windows/10.00/it/cookies.html\" target=\"_blank\" rel=\"noopener noreferrer\">Opera</a> - <a title=\"Impostazioni web per Safari sull�iPhone, sull�iPad, o sull�iPod touch\" href=\"https://support.apple.com/it-it/HT201265\" target=\"_blank\" rel=\"noopener noreferrer\">Apple Safari</a></div>", 4)
const _hoisted_29 = [
  _hoisted_25
]
const _hoisted_30 = { style: {"margin-top":"20px","margin-bottom":"15px"} }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<h1><strong>Cookie di terze parti</strong></h1><p> Questo sito funge anche da intermediario per cookie di terze parti (come i pulsanti per i social network), utilizzati per poter fornire ulteriori servizi e funzionalita&#39; ai visitatori e per semplificare l&#39;uso del sito stesso, o per fornire pubblicita&#39; personalizzata. Questo sito non ha alcun controllo sui loro cookie interamente gestiti dalle terze parti e non ha accesso alle informazioni raccolte tramite detti cookie. Le informazioni sull&#39;uso dei detti cookie e sulle finalita&#39; degli stessi, nonche&#39; sulle modalita&#39; per l&#39;eventuale disabilitazione, sono fornite direttamente dalle terze parti alle pagine indicate di seguito. </p><p>Il presente sito utilizza cookie delle seguenti terze parti.</p><p> - <strong>Google Analytics: </strong> utilizzato per analizzare l&#39;uso del sito da parte degli utenti, compilare report sulle attività del sito e il comportamento degli utenti, verificare quanto spesso gli utenti visitano il sito, come il sito viene rintracciato e quali pagine sono visitate piu&#39; frequentemente. Le informazioni sono combinate con informazioni raccolte da altri siti al fine di creare un quadro comparativo dell&#39;uso del sito rispetto ad altri siti delle medesima categoria. <br>Dati raccolti: identificativo del browser, data e orario di interazione col sito, pagina di provenienza, indirizzo IP. <br>Luogo di trattamento dei dati: Unione europea essendo attiva l&#39;anonimizzazione del servizio. </p><p> I dati raccolti non consentono l&#39;identificazione personale degli utenti, e non sono incrociati con altre informazioni relative alla stessa persone. Sono <strong>anonimizzati</strong> (troncati all&#39;ultimo ottetto). In base ad apposito accordo e&#39; vietato a Google Inc. l&#39;incrocio di tali dati con quelli ricavati da altri servizi. </p>", 5)
const _hoisted_36 = [
  _hoisted_31
]
const _hoisted_37 = { style: {"margin-top":"20px","margin-bottom":"15px"} }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Ulteriori informazioni sui cookies di Google Analytics si trovano alla pagina "),
  /*#__PURE__*/_createElementVNode("a", {
    title: "Google Analytics Cookie Usage on Websites",
    href: "https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage",
    target: "_blank",
    rel: "noopener"
  }, "Google Analytics Cookie Usage on Websites"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#000000"} }, [
    /*#__PURE__*/_createTextVNode("L'utente puo' "),
    /*#__PURE__*/_createElementVNode("strong", null, "disabilitare"),
    /*#__PURE__*/_createTextVNode(" (opt-out) in modo selettivo la raccolta dei dati da parte di Google Analytics ")
  ]),
  /*#__PURE__*/_createTextVNode(" installando sul proprio browser l'"),
  /*#__PURE__*/_createElementVNode("a", {
    title: "Componente aggiuntivo del browser per la disattivazione di Google Analytics",
    href: "https://tools.google.com/dlpage/gaoptout",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "apposito componente fornito da Google"),
  /*#__PURE__*/_createTextVNode(" (opt out). "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex flex-col h-screen mt-4",
  style: {"width":"70vw","font-family":"sans-serif","padding":"40px","text-align":"justify"}
}, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" La nostra Cookie Policy e' scaricabile cliccando su: "),
    /*#__PURE__*/_createElementVNode("a", { href: "informative/cookiePolicy.pdf" }, "Cookie Policy")
  ])
], -1)

import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import router from '@/router';
import { ref, reactive } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CookiePolicy',
  setup(__props) {

const store = patientStore();
const { patient } = storeToRefs(store);
const cookiePresent = ref(true);
const panels = reactive({
    cookieInfo: false,
    disableCookies: false,
    thirdPartyCookies: false,
    additionalInfo: false,
});
const consent = getConsent('consent');

function getConsent(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function togglePanel(panelName: string) {
    panels[panelName] = !panels[panelName];
}

function acceptCookie() {

}

function revokeCookie() {
    // Ottieni tutti i cookie
    const cookies = document.cookie.split(";");

    // Itera su ogni cookie e impostalo con una scadenza passata
    cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        // Imposta il cookie con una scadenza passata per eliminarlo
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });
    alert('Cookies eliminati correttamente')
}

function refuseCookie() {

}


return (_ctx: any,_cache: any) => {
  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            (cookiePresent.value)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_4, "Hai accettato (il " + _toDisplayString(_unref(consent)) + ") l'uso dei seguenti cookie:", 1))
              : (_openBlock(), _createElementBlock("h1", _hoisted_5, " Non hai acconsentito all'utilizzo dei cookie ")),
            _hoisted_6,
            (cookiePresent.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800",
                    onClick: revokeCookie
                  }, "Revoca l'utilizzo dei cookie.")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h4", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (togglePanel('cookieInfo'))),
                style: {"font-size":"20px","cursor":"pointer"}
              }, "Cookie: cosa sono e a che servono"),
              _hoisted_15
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_16, _hoisted_23, 512), [
              [_vShow, panels.cookieInfo]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("h4", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (togglePanel('disableCookies'))),
                style: {"font-size":"20px","cursor":"pointer"}
              }, "Come disabilitare i cookie")
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_24, _hoisted_29, 512), [
              [_vShow, panels.disableCookies]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("h4", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (togglePanel('thirdPartyCookies'))),
                style: {"font-size":"20px","cursor":"pointer"}
              }, "Cookie di terze parti")
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_30, _hoisted_36, 512), [
              [_vShow, panels.thirdPartyCookies]
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("h4", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (togglePanel('additionalInfo'))),
                style: {"font-size":"20px","cursor":"pointer"}
              }, "Ulteriori Informazioni")
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_37, _hoisted_39, 512), [
              [_vShow, panels.additionalInfo]
            ])
          ])
        ]),
        _hoisted_40,
        _hoisted_41
      ]))
    : _createCommentVNode("", true)
}
}

})